import script from "./gameSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./gameSlider.vue?vue&type=script&setup=true&lang=js"

import "./gameSlider.vue?vue&type=style&index=0&id=5c130f44&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c130f44"]])

export default __exports__